import React from "react";
import { BadgeCheck } from "lucide-react";

export function VerifiedBadge({ size = 16, withLabel = false }) {
    return (
        <span className="inline-flex items-center gap-1 text-sage align-middle" title="Editor verificato" data-testid="verified-badge">
            <BadgeCheck size={size} strokeWidth={2} />
            {withLabel && <span className="text-xs font-medium uppercase tracking-wider">Verificato</span>}
        </span>
    );
}
